


























import Vue from 'vue';

export default Vue.extend({
  name: 'WizeBankTable',

  props: {
    headers: {
      type: Array,
    },
    items: {
      type: Array,
    },
    itemsPerPage: {
      default: 25,
      type: Number,
    },
    search: {
      default: '',
      type: String,
    },
    showExpand: {
      default: false,
      type: Boolean,
    },
    disableSort: {
      default: false,
      type: Boolean,
    },
    expanded: {
      default: () => [],
      type: Array,
    },
    onItemExpanded: {
      default: () => [],
      type: Array,
    },
  },
});
